import { getAuth } from "@firebase/auth";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GetSingleCourse from "../../../../Controllers/Admin/ClassAndCourses/GetSingleCourse";
import CreateResult from "../../../../Controllers/Admin/Results/CreateResult";
import GetAllStudentsOfClass from "../../../../Controllers/Admin/Results/GetAllStudentsOfClass";
import GetUser from "../../../../Controllers/Users/GetUser";
import uniqid from "uniqid";
import UpdateExamForResult from "../../../../Controllers/Admin/Exams/UpdateExamForResult";
import GetSingleExam from "../../../../Controllers/Admin/Exams/GetSingleExam";

export default function AddResultViewModel() {
  const location = useLocation();
  const navigate = useNavigate();
  const [AuthUser, setAuthUser] = useState();
  const [ResultDocumentID, setResultDocumentID] = useState(
    uniqid() + uniqid() + uniqid()
  );

  const [ExamType, setExamType] = useState("");
  const [CourseName, setCourseName] = useState("");

  const [ObtainedMarksError, setObtainedMarksError] = useState(false);
  const [IsCheckError, setIsCheckError] = useState(false);

  const [IsLoading, setIsLoading] = useState(false);
  const [FormDisabled, setFormDisabled] = useState(false);
  const [SchoolID, setSchoolID] = useState("");
  const [ClassID, setClassID] = useState("");
  const [CourseID, setCourseID] = useState("");
  const [ExamID, setExamID] = useState("");
  const [StudentsArray, setStudentsArray] = useState([]);

  const [StudentsMarks, setStudentsMarks] = useState([]);
  const [ExamCourse, setExamCourse] = useState({});
  const [ExamData, setExamData] = useState({});

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    setExamID(location.pathname.split("/").slice(-3, -2)[0]);
    setCourseID(location.pathname.split("/").slice(-5, -4)[0]);
    setClassID(location.pathname.split("/").slice(-7, -6)[0]);
  }, [location.pathname]);

  useEffect(() => {
    async function fetchData() {
      const CourseData = await GetSingleCourse(CourseID);
      const ArrayOfWords = CourseData?.CourseName.split(" ");
      for (var i = 0; i < ArrayOfWords.length; i++) {
        ArrayOfWords[i] =
          ArrayOfWords[i].charAt(0).toUpperCase() + ArrayOfWords[i].slice(1);
      }
      const StringOfWords = ArrayOfWords.join(" ");
      setCourseName(StringOfWords);
      setExamCourse(CourseData);
    }
    fetchData();
  }, [CourseID]);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const studentsArray = await GetAllStudentsOfClass(SchoolID, ClassID);
      setStudentsArray(studentsArray);
      setIsLoading(false);
    }
    fetchData();
  }, [SchoolID, ClassID]);

  useEffect(() => {
    async function fetchData() {
      const ExamObject = await GetSingleExam(ExamID);
      setExamData(ExamObject);

      const ArrayOfWords = ExamObject?.ExamName.split(" ");
      for (var i = 0; i < ArrayOfWords.length; i++) {
        ArrayOfWords[i] =
          ArrayOfWords[i].charAt(0).toUpperCase() + ArrayOfWords[i].slice(1);
      }
      const StringOfWords = ArrayOfWords.join(" ");
      setExamType(StringOfWords);
    }
    fetchData();
  }, [ExamID]);

  const UIErrorHandling = useCallback(() => {
    let flag = 0;

    if (
      StudentsMarks.length === 0 ||
      StudentsMarks.length !== StudentsArray.length
    ) {
      setObtainedMarksError(true);
      flag++;
    } else {
      setObtainedMarksError(false);
    }

    return flag;
  }, [StudentsMarks.length, StudentsArray.length]);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, UIErrorHandling]);

  const RegisterResult = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();
    if (flag === 0) {
      setFormDisabled(true);
      const ResultObject = {
        StudentsMarks: StudentsMarks,
        SchoolID: SchoolID,
        ClassID: ClassID,
        CourseID: CourseID,
        ExamID: ExamID,
        TeacherID: ExamCourse?.Teacher?.id,
      };

      await CreateResult(ResultDocumentID, ResultObject, AuthUser.uid)
        .then(() => {
          UpdateExamForResult(ResultDocumentID, ExamID);
          navigate(
            `/user/${AuthUser?.UserType}/classes/${ClassID}/courses/${CourseID}/exams`
          );
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setFormDisabled(false);
    }
  };

  return {
    RegisterResult,
    StudentsMarks,
    setStudentsMarks,
    StudentsArray,
    FormDisabled,
    IsLoading,
    ObtainedMarksError,
    ExamData,
    ExamType,
    CourseName,
  };
}
